import lodash from "lodash";
import {
    createManageDelete,
    createManageExportCsv,
    createPage,
    createRowActionEdit,
    createRowActionView
} from "../../../../utils/page";
import { has } from "../../../../utils/menu-context";
import { conditionFormChecker, initUseForm, onClickDeleteAllClient, putField } from "../../../../utils/form";
import { createButtonCreate } from "../../../../utils/button";
import i18n from "../../../../i18n";
import { createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import store from "../../../../store";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { addModal } from "../../../../app.logic";
import { modalStyleForm } from "../../../../utils/constant";
import { required, validateError } from "../../../../utils/validate";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { createLoading } from "../../../../utils/loading";
import {
    createFieldRichTextEditor,
    createFieldSelect
} from "../../../../components/input/template-builder/template-builder.logic";
import { checkTooltipLabel } from "./certificate-request.section";
export const { isLoading, setIsLoading } = createLoading()

export const callScientificType = ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'SCIENTIFIC_TYPE', value: searchQuery })
const CertificateAquaticScientificNameForm = defineAsyncComponent(() => import('./CertificateAquaticScientificNameForm'))

export const createColumns = () => {
    const columns = []
    columns.push(createColumnInput({
        title: () => i18n.global.t("model.aquaticScientificName.scientificName"),
        customRender: ({ record }) => <div class="ql-container ql-snow disabled">
            <div class="ql-editor" innerHTML={record.scientificName}></div>
        </div>,
        dataIndex: "scientificName",
        align: 'center',
    }))
    columns.push(createColumnSelect({
        title: () => i18n.global.t("model.aquaticScientificName.refScientificType"),
        dataIndex: "refScientificType.value",
        align: 'center',
        customRender: ({ record, column }) => checkTooltipLabel({ field: column, keySuffix: "value", labelTitle: record.refScientificType?.value, parentModel: record.refParent, model: record }),
        inputProp: () => ({ list: callScientificType, optLabel: 'value' }),
        search: { name: "refScientificType.id" },
    }))
    return columns
}

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, /*isTmp,*/ visibleEdit } = props
    const { useForm } = data
    const { modelRef } = useForm
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef
    data.columns = createColumns({ props, data })
    data.page = createPage({ data: items })
    data.tableOptions = { search: { activeKey: null } }
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => viewOnly ? false : has({ menuContext, key: 'canDelete' }),
            onClick: ({ rowSelection }) => onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey }),
        }),
        createManageExportCsv({ menuContext }),
    ]
    data.manageExtras = []
    data.rowActions = []
    if (!viewOnly) {
        // if(!isTmp) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => openModalForm({ props, items }),
                        options: { text: i18n.global.t('model.aquaticScientificName.modalName') }
                    }),
                }),
                visible: () => !viewOnly,
            })
        // }

        data.rowActions.push(createRowActionEdit({
            menuContext,
            onClick: ({ record }) => openModalForm({ props: { menuContext, viewOnly, setAppPageHeader: false, form: record} }),
            visible: () => has({ menuContext: menuContext, key: 'canEdit' }) && visibleEdit
        }))
    }
    data.rowActions.push(createRowActionView({
        menuContext,
        onClick: ({ record }) => openModalForm({ props: { menuContext, viewOnly: true, setAppPageHeader: false, form: record } }),
        visible: () => has({ menuContext: menuContext, key: 'canView' })
    }))
}

export const createForm = () => {
    return {
        refCertificateRequest: null,
        scientificName: null,
        refScientificType: null,
    }
}

export const createRules = () => {
    return {
        scientificName: [required],
        refScientificType: [required],
    }
}

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldRichTextEditor({
                key: `${prefix}scientificName`,
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.aquaticScientificName.scientificName'),
                inputProp: () => ({
                    content: model.scientificName,
                    "onUpdate:content": value => model.scientificName = value,
                    disabled: viewOnly,
                })
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                key: `${prefix}refScientificType`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.aquaticScientificName.refScientificType'),
                inputProp: ({ field }) => (lodash.merge({
                    value: model.refScientificType,
                    'onUpdate:value': value => model.refScientificType = value,
                    disabled: viewOnly,
                    list: callScientificType,
                    optKey: 'key',
                    optLabel: 'value'
                }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
        ]
    })
}

export const loadForm = ({ props, data }) => {
    setIsLoading(true)
    const { form } = props
    const { useForm } = data
    const { modelRef } = useForm
    let promise = null
    if (form) {
        promise = Promise.resolve({ data: [form] })
    } else {
        promise = Promise.resolve({ data: [modelRef] })
    }
    return promise
        .then(page => initUseForm({ data, page }))
        .finally(() => setIsLoading(false))
}

export const initForm = ({ props, data, refs }) => {
    data.form = createForm();
    data.rules = createRules();
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs })
}

export const openModalForm = ({ props, items }) => {
    const refs = reactive({ form: null })
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            width: '50%',
            okButtonProps: { disabled: props.viewOnly },
            header: i18n.global.t('model.aquaticScientificName.modelName'),
            onOk: () => {
                refs.form.callOnClickModalOk()
                    .then((record) => {
                        if (items) {
                            items.push(record)
                        } else {
                            lodash.merge(props.form, record)
                        }
                        options.bind.onCancel()
                    })
            }
        }),
        render: () => <CertificateAquaticScientificNameForm ref={(e) => { if (e) refs.form = e }} {...props}></CertificateAquaticScientificNameForm>
    })
    return options
}

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error })
            throw error
        });
}